module.exports = __webpack_public_path__ + "dc-a9c02744dc8dc7b5cf3a.png";